import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function FooterCta() {
  const { user } = useAuth();

  return (
    <section className="mx-auto max-w-7xl px-4 pb-4 pt-8 sm:pb-6 sm:pt-12" data-testid="footer-cta">
      <div className="relative isolate overflow-hidden rounded-3xl border border-primary/30 bg-brand-ink px-6 py-12 text-center shadow-brand sm:px-12 sm:py-16">
        <div aria-hidden className="pointer-events-none absolute inset-0 -z-10">
          <div className="absolute -left-20 -top-24 h-72 w-72 rounded-full bg-brand-emerald opacity-35 blur-3xl motion-safe:animate-mesh" />
          <div className="absolute -bottom-28 -right-16 h-80 w-80 rounded-full bg-brand-lime opacity-20 blur-3xl motion-safe:animate-mesh [animation-delay:-8s]" />
          <div className="cta-grid absolute inset-0 opacity-50" />
        </div>

        <h2 className="mx-auto max-w-2xl font-display text-3xl font-semibold leading-tight text-white sm:text-5xl">
          Ready to trade on{" "}
          <span className="bg-[linear-gradient(120deg,oklch(var(--brand-emerald)),oklch(var(--brand-lime)))] bg-clip-text text-transparent">
            PaisaCX
          </span>
          ?
        </h2>
        <p className="mx-auto mt-4 max-w-lg text-sm leading-6 text-white/65 sm:text-base sm:leading-7">
          Open a free account, match with verified merchants, and settle every order under escrow —
          or move size through the OTC desk.
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          {user ? (
            <Link
              to="/p2p"
              className="brand-gradient inline-flex h-12 w-full items-center justify-center gap-2 rounded-md px-7 text-sm font-medium text-primary-foreground shadow-brand sm:w-auto"
            >
              Browse P2P offers <ArrowRight className="h-4 w-4" />
            </Link>
          ) : (
            <Link
              to="/register"
              className="group/btn relative inline-flex h-12 w-full items-center justify-center gap-2 overflow-hidden rounded-md bg-[linear-gradient(120deg,oklch(var(--brand-emerald)),oklch(var(--brand-lime)))] px-7 text-sm font-semibold text-brand-ink shadow-brand hover:opacity-95 sm:w-auto"
            >
              <span className="absolute inset-0 -translate-x-full bg-[linear-gradient(100deg,transparent,rgb(255_255_255/0.45),transparent)] transition-transform duration-700 group-hover/btn:translate-x-full" />
              Create free account <ArrowRight className="h-4 w-4 transition-transform group-hover/btn:translate-x-1" />
            </Link>
          )}
          <Link
            to="/markets"
            className="inline-flex h-12 w-full items-center justify-center rounded-md border border-white/20 bg-white/5 px-7 text-sm font-medium text-white transition hover:bg-white/10 hover:text-white sm:w-auto"
          >
            Explore markets
          </Link>
        </div>

        <p className="mt-6 inline-flex items-center gap-1.5 text-xs text-white/45">
          <ShieldCheck className="h-3.5 w-3.5" /> Escrow on every P2P order · Markets open 24/7
        </p>
      </div>
    </section>
  );
}
